import { render, staticRenderFns } from "./datajob-record-filter.vue?vue&type=template&id=bb975fd8&scoped=true&"
import script from "./datajob-record-filter.vue?vue&type=script&lang=ts&"
export * from "./datajob-record-filter.vue?vue&type=script&lang=ts&"
import style0 from "./datajob-record-filter.vue?vue&type=style&index=0&id=bb975fd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb975fd8",
  null
  
)

export default component.exports